/**
 * Private route
 */

// React
import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

// Components
import AppLayout from 'app/AppLayout';

// Hooks
import useLocalStorage from 'hooks/useLocalStorage';

// Libraries
import { useRecoilState } from 'recoil';

// Utils
import { STORAGE_KEYS } from 'utils/constants';

// Hook
import useServicesAndBanners from 'hooks/useServicesAndBanner';

// Router
import ROUTES from 'configs/route';

// Recoil
import { userInfoAtom } from 'recoil/UserInfoRecoil';

// Utils
import { CombinedRouteProps } from 'utils/types';

// Define the PrivateRoute component
const PrivateRoute: React.FC<CombinedRouteProps> = ({
  children,
  showHeader = true,
  showFooter = true,
  maxWidth,
  alignItems = 'start',
  background = '#FFFFFF',
}) => {
  const [accessToken] = useLocalStorage(STORAGE_KEYS.ACCESS_TOKEN);
  const [userInfo] = useRecoilState(userInfoAtom);
  const { fetchServiceAndBanners } = useServicesAndBanners();
  const location = useLocation();

  useEffect(() => {
    if (accessToken && !userInfo?.id) {
      localStorage.removeItem(STORAGE_KEYS.USER_REGISTER);
      fetchServiceAndBanners(true);
    }
  }, [accessToken]);

  if (!accessToken) {
    // Not logged in, redirect to login page with the return url
    return <Navigate to={ROUTES.LOGIN} state={{ from: location }} />;
  }

  // Authorized, so return the children wrapped with AppLayout
  return (
    <AppLayout
      showHeader={showHeader}
      alignItems={alignItems}
      showFooter={showFooter}
      maxWidth={maxWidth}
      background={background}
    >
      {children}
    </AppLayout>
  );
};

export default PrivateRoute;
